// Schede d'ESEMPIO per l'onboarding (nessuna personalizzazione automatica):
// definizioni statiche, create come normali schede dell'utente con le API
// esistenti. L'utente può modificare/eliminare tutto. I template del catalogo
// sono risolti a runtime per nome normalizzato: se un nome non matcha,
// l'esercizio viene creato comunque (solo per nome), senza rompere il flusso.
import { getExerciseTemplates, createSelfProgram, createWorkout, createExercise, reassignAthleteProgram, getAthletePrograms } from './database';

// Rispecchia normalize_exercise_name del DB quanto basta per i nomi che controlliamo.
const normalizeName = (s) =>
  (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const REST = 90;

// Nomi VERIFICATI sul catalogo di produzione (2026-07-10).
export const STARTER_PROGRAMS = {
  3: {
    name: 'Full Body 3 giorni — esempio',
    description:
      "Scheda d'esempio creata da Uptra: un punto di partenza, non un programma personalizzato. Modifica esercizi, serie e carichi in base a come ti alleni.",
    days: [
      {
        name: 'Giorno A',
        exercises: [
          { name: 'Leg Press', sets: 3, reps: 10 },
          { name: 'Panca Piana Manubri', sets: 3, reps: 10 },
          { name: 'Lat Machine Presa Larga', sets: 3, reps: 10 },
          { name: 'Plank', sets: 3, reps: 30 }, // hold: 30 secondi
        ],
      },
      {
        name: 'Giorno B',
        exercises: [
          { name: 'Leg Curl', sets: 3, reps: 10 },
          { name: 'Military Press', sets: 3, reps: 10 },
          { name: 'Pulley Basso', sets: 3, reps: 10 },
          { name: 'Crunch', sets: 3, reps: 12 },
        ],
      },
      {
        name: 'Giorno C',
        exercises: [
          { name: 'Goblet Squat', sets: 3, reps: 10 },
          { name: 'Spinte Panca Inclinata con Manubri', sets: 3, reps: 10 },
          { name: 'Rematore Manubrio', sets: 3, reps: 10 },
          { name: 'Alzate Laterali', sets: 3, reps: 12 },
        ],
      },
    ],
  },
  2: {
    name: 'Full Body 2 giorni — esempio',
    description:
      "Scheda d'esempio creata da Uptra: un punto di partenza, non un programma personalizzato. Modifica esercizi, serie e carichi in base a come ti alleni.",
    days: [
      {
        name: 'Giorno A',
        exercises: [
          { name: 'Leg Press', sets: 3, reps: 10 },
          { name: 'Panca Piana Manubri', sets: 3, reps: 10 },
          { name: 'Lat Machine Presa Larga', sets: 3, reps: 10 },
          { name: 'Alzate Laterali', sets: 3, reps: 12 },
          { name: 'Plank', sets: 3, reps: 30 },
        ],
      },
      {
        name: 'Giorno B',
        exercises: [
          { name: 'Goblet Squat', sets: 3, reps: 10 },
          { name: 'Leg Curl', sets: 3, reps: 10 },
          { name: 'Military Press', sets: 3, reps: 10 },
          { name: 'Pulley Basso', sets: 3, reps: 10 },
          { name: 'Crunch', sets: 3, reps: 12 },
        ],
      },
    ],
  },
};

// Crea la scheda d'esempio per l'utente e la imposta come attiva.
// Ritorna il programma creato. Lancia in caso di errore (il chiamante mostra il toast).
export const createStarterProgram = async (athleteId, daysCount) => {
  const def = STARTER_PROGRAMS[daysCount];
  if (!def) throw new Error(`Starter non definita per ${daysCount} giorni`);

  // Anti-duplicato: se una starter con lo stesso nome esiste già (tentativo
  // precedente fallito dopo la creazione, o doppio tap oltre la guardia UI),
  // NON ricrearla: riattiva quella esistente. L'utente può comunque
  // modificarla/completarla dall'editor.
  const existing = await getAthletePrograms(athleteId);
  const duplicate = (existing || []).find(ap => ap.program?.name === def.name);
  if (duplicate) {
    await reassignAthleteProgram(athleteId, duplicate.program.id);
    return duplicate.program;
  }

  // Risolvi i template del catalogo per nome normalizzato (best-effort).
  const templates = await getExerciseTemplates();
  const byName = {};
  (templates || []).forEach((t) => { byName[normalizeName(t.name)] = t.id; });

  const program = await createSelfProgram(athleteId, {
    name: def.name,
    description: def.description,
  });

  for (let d = 0; d < def.days.length; d++) {
    const day = def.days[d];
    const workout = await createWorkout(program.id, { name: day.name, day_number: d + 1 });
    for (let i = 0; i < day.exercises.length; i++) {
      const ex = day.exercises[i];
      await createExercise(workout.id, {
        name: ex.name,
        sets: ex.sets,
        reps: ex.reps,
        rest_seconds: REST,
        exercise_order: i + 1,
        exercise_template_id: byName[normalizeName(ex.name)] || null,
      });
    }
  }

  // Attivala: la dashboard mostrerà subito "Inizia Allenamento".
  await reassignAthleteProgram(athleteId, program.id);
  return program;
};
